goog.provide("shadow.js.shim.module$src$svg$wpp$content$people_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content$people_svg");
shadow.js.shim.module$src$svg$wpp$content$people_svg = shadow.js.nativeProvides["src/svg/wpp/content/people.svg"] = shadow$bridge("src/svg/wpp/content/people.svg");
module$shadow_js_shim_module$src$svg$wpp$content$people_svg.default = shadow.js.shim.module$src$svg$wpp$content$people_svg;
